import { memo } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { PrizeWallFinishedProps } from './PrizeWallFinished.types';

function PrizeWallFinished({ onButtonPress }: PrizeWallFinishedProps) {
  return (
    <Box gap="space-400" paddingTop="space-600">
      <Image
        name="common.Hourglass"
        alignSelf="center"
        width={120}
        height={120}
      />
      <Text
        variant="body-s"
        locNS="prizeWall"
        locKey="prizeWallFinishedDescription"
        textAlign="center"
        color="darkSurfacePrimary"
      />
      <Button
        locNS="prizeWall"
        locKey="prizeWallFinishedButton"
        marginTop="space-200"
        onPress={onButtonPress}
      />
    </Box>
  );
}

export default memo(PrizeWallFinished);
